/**
 * Based on https://stackoverflow.com/a/51564734
 */
export function hex2rgba(hex: string, alpha = 1): string {
  const matches = hex.match(/\w\w/g);
  if (!matches || matches.length !== 3) {
    throw new Error(`Could not convert \`${hex}\` to rgba`);
  }
  const [r, g, b] = matches.map((x) => parseInt(x, 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
